import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastService } from "@app/shared/ui";
import { TranslocoModule, TranslocoService } from "@ngneat/transloco";
import { PaymentService } from "clearline-api";
import { AppConfigService } from "core-kit";
import { switchMap, take } from "rxjs/operators";
import { ChargebeePaymentService, ChargebeePaymentServiceConfig } from "./chargebee-payment.service";

@Component({
  selector: "app-payment-method-update",
  templateUrl: "./payment-method-update.component.html",
  styleUrls: ["./payment-method-update.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [AsyncPipe, TranslocoModule],
  providers: [ChargebeePaymentService]
})
export class PaymentMethodUpdateComponent implements OnInit, OnDestroy {
  canSubmit$ = this.chargebeePaymentService.canSubmit$;
  isProcessing$ = this.chargebeePaymentService.isProcessing$;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: ChargebeePaymentServiceConfig,
    private configService: AppConfigService,
    private dialogRef: MatDialogRef<PaymentMethodUpdateComponent>,
    private chargebeePaymentService: ChargebeePaymentService,
    private toaster: ToastService,
    private transloco: TranslocoService,
    private paymentService: PaymentService
  ) {}

  ngOnInit() {
    const { chargebee } = this.configService.appData;

    if (!chargebee) {
      console.error("Chargebee configuration is missing in app data.");
      return;
    }

    const { account, publishableKey } = chargebee;

    this.chargebeePaymentService.initPaymentIntent(this.data, account, publishableKey);
    this.chargebeePaymentService.onSuccess$
      .pipe(
        switchMap((id) => this.paymentService.updatePaymentMethod(id)),
        take(1)
      )
      .subscribe((result) => {
        const message = this.transloco.translate("payment.updateSuccessMessage");
        this.toaster.success(message);
        this.dialogRef.close(result);
      });
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    this.chargebeePaymentService.submit();
  }

  ngOnDestroy(): void {
    this.chargebeePaymentService.cleanup();
  }
}
